export default class Validator {
    constructor() {
        this.decimalSeparator = '.';
    }

    zipcode(value) {
        return !!(value.match(/^((0[125-9])|([12][0-8])|(3[0-69])|(4[0-7])|([58][0-9])|(6[02389])|(7[0-35-8])|(9[013-8]))[0-9]{3}$/));
    }
}
